<template>
  <v-app>
    <the-parsina-header
      v-if="
        $route.matched[1].name == 'ParsinaSupport' &&
        $route.name != 'parsinaSupportLogin'
      "
    />
    <the-header v-if="$route.matched[1].name != 'ParsinaSupport'" />

    <the-alerts />

    <v-main
      :class="{
        'dashboard-page':
          ($route.name === 'PACNTDashboard' && hasDashboardData) ||
          $route.name === 'PBANKDashboard' ||
          $route.name === 'PHAMYARDashboard' ||
          $route.name === 'PCRMDashboard' ||
          $route.name === 'PHAMSAZDashboard' ||
          $route.name === 'Dashboard',
      }"
    >
      <keep-alive :max="20">
        <router-view v-if="cachedTabKey" :key="cachedTabKey"></router-view>
      </keep-alive>
      <transition v-if="!cachedTabKey" name="fade" mode="out-in">
        <router-view :key="$route.path"></router-view>
      </transition>

      <the-loading />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import TheHeader from "@/containers/TheHeader";
import TheParsinaHeader from "@/containers/TheParsinaHeader";
import TheAlerts from "@/components/TheAlerts";
import TheLoading from "@/components/TheLoading";
import { EventBus } from "@/plugins/eventBus.js";
import {
  cacheKeyOf,
  clearRouteFilterState,
  isKeepAliveRoute,
  isMultiTabRoute,
  tabOfCacheKey,
  TAB_CLOSED_EVENT,
} from "@/plugins/multiTabRoutes";

export default {
  name: "TheContainer",
  components: {
    TheHeader,
    TheParsinaHeader,
    TheAlerts,
    TheLoading,
  },

  data() {
    return {
      pendingEvictions: [],
    };
  },

  computed: {
    ...mapGetters({
      items: "pacntX/dashboardAccountOffice",
    }),
    hasDashboardData() {
      return this.items;
    },
    cachedTabKey() {
      return isKeepAliveRoute(this.$route) ? cacheKeyOf(this.$route) : null;
    },
  },
  watch: {
    cachedTabKey(key, oldKey) {
      if (oldKey && key && tabOfCacheKey(oldKey) === tabOfCacheKey(key)) {
        this.dropCached(oldKey);
      }
      const pending = this.pendingEvictions;
      this.pendingEvictions = [];
      pending.forEach((tab) => this.evictTab(tab));
    },
  },
  mounted() {
    this.$store.dispatch("phamyarX/restoreTaskTimers");
    this.unregisterRouterHook = this.$router.beforeEach((to, from, next) => {
      this.closeVuetifyTooltips();
      next();
    });
    EventBus.$on(TAB_CLOSED_EVENT, this.evictTab);
  },

  beforeDestroy() {
    this.unregisterRouterHook?.();
    EventBus.$off(TAB_CLOSED_EVENT, this.evictTab);
  },

  methods: {
    // tab: tabKeyOf تب بسته‌شده
    evictTab(tab) {
      if (tab === tabOfCacheKey(this.cachedTabKey)) {
        if (!this.pendingEvictions.includes(tab)) {
          this.pendingEvictions.push(tab);
        }
        return;
      }
      const cache = this.tabCache();
      if (cache) {
        cache.keys
          .filter((key) => tabOfCacheKey(key) === tab)
          .forEach((key) => this.dropCached(key));
      }
      // کلید مسیرهای غیرچندتبی همان نام مسیر است
      if (!isMultiTabRoute(tab)) clearRouteFilterState(tab);
    },
    dropCached(key) {
      const cache = this.tabCache();
      const entry = cache && cache.cache[key];
      if (!entry) return;
      if (entry.componentInstance) entry.componentInstance.$destroy();
      delete cache.cache[key];
      const index = cache.keys.indexOf(key);
      if (index > -1) cache.keys.splice(index, 1);
    },
    // keep-alive کامپوننت abstract است: Vue دیتای آن (از جمله ref) را دور می‌ریزد و در
    // $children هم نمی‌آید؛ پس نمونه‌اش از درخت vnode پیدا می‌شود (کم‌عمق‌ترین keep-alive)
    tabCache() {
      let level = [this._vnode];
      while (level.length) {
        const next = [];
        for (const vnode of level) {
          if (!vnode) continue;
          const options = vnode.componentOptions;
          if (options && options.Ctor.options.name === "keep-alive") {
            return vnode.componentInstance;
          }
          if (vnode.children) next.push(...vnode.children);
          if (vnode.componentInstance) next.push(vnode.componentInstance._vnode);
        }
        level = next;
      }
      return null;
    },
    closeVuetifyTooltips(vm = this.$root) {
      if (vm === this.$root) document.activeElement?.blur();

      vm.$children.forEach((child) => {
        const name = child.$options.name;
        if ((name === "v-menu" || name === "v-tooltip") && child.isActive) {
          child.isActive = false;
        }
        this.closeVuetifyTooltips(child);
      });
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
